import React, { Component } from 'react'
import { getCustomerViewUrl, getSearchViewUrl } from '../Lib/View360Request'
import Globals from "../Globals"
import LibInfo from "../Lib/Info"

class IframeView360 extends Component
{

    constructor(props) {
        super(props)
        if (!localStorage.user_IDClient || !localStorage.user_login || !localStorage.user_password) {
            localStorage.bypass_iFrame = true
            localStorage.user_IDClient = this.props.location.query.idClient
            localStorage.user_login = this.props.location.query.login
            localStorage.user_password = this.props.location.query.password
            localStorage.token = 'iframe'
            localStorage.version = Globals.VERSION

            localStorage.ClientApiURL = Globals.API_URL
            var parts = window.location.hostname.split('.')
            if (parts[0] === 'dev' || parts[1] === 'dev' || parts[0] === 'preprod' || parts[0] === 'localhost') {
                localStorage.ClientApiURL = Globals.API_URL_DEV
            }
        }
    }

    async fetchTenant() {
        const userInfo = await LibInfo.get()
        return userInfo.SousDomaine
    }

    async componentDidMount() {
        //Si param customerId, on récupère l'URl de la fiche 360 du customer, sinon, celle de la recherche
        const customerId = this.props.location.query.customerId
        //On récupère le tenant
        const tenant = await this.fetchTenant()

        const url = customerId
            ? await getCustomerViewUrl(customerId, tenant)
            : await getSearchViewUrl(tenant)
        if (url) {
            //On redirige la page elle même sur l'URL
            window.location.href = url
        } else {
            alert("Une erreur s'est produite lors de la récupération de l'URl de la fiche 360")
        }
    }

    render() {
        return (
            <div className="center-div" style={{ paddingTop: '100px' }}>
                <i className="fa fa-refresh fa-spin fa-fw"></i>
            </div>
        )
    }
}

export default IframeView360
